import {inject, Injectable} from "@angular/core";
import {Database, objectVal, ref} from "@angular/fire/database";
import {ActivationEnd, Router} from "@angular/router";
import {filter, map, Observable, race, switchMap} from "rxjs";
import {EventDataService} from "./event-data.service";

@Injectable({
  providedIn: 'root',
})
export class RouteValidatorService {
  private readonly router = inject(Router);
  private readonly db = inject(Database);
  private readonly eventDataService = inject(EventDataService);

  constructor() {
    this.router.events.pipe(
      filter((e): e is ActivationEnd => e instanceof ActivationEnd),
      filter(e => !!e.snapshot?.component),
      switchMap(e => {
        const snap = e.snapshot;
        const regionKey = snap.params?.['regionKey'];
        const eventKey = snap.params?.['eventKey'];
        const teamNumber = snap.params?.['teamNumber'];

        let validators: Observable<{message: string, eventKey: string}>[] = [];
        if(regionKey) {
          validators.push(this.eventDataService.getRegionName(regionKey).pipe(filter(n => !n), map(() => ({message: 'Region not found', eventKey}))));

          if(eventKey) {
            validators.push(this.eventDataService.getEventName(regionKey, eventKey).pipe(filter(n => !n), map(() => ({message: 'Event not found', eventKey}))));

            if(teamNumber) {
              validators.push(objectVal(ref(this.db, `regions/${regionKey}/events/${eventKey}/teams/${teamNumber}`)).pipe(filter(k => k === null), map(() => ({message: `${teamNumber} is not in team list`, eventKey}))));
            }
          }
        }

        return race(validators);
      }),
    ).subscribe(message => {
      this.router.navigateByUrl(`/error?title=${message.message}&details=${message.eventKey}`);
    });
  }
}
